import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  root: {
    verticalAlign: 'middle',
    color: '#981B49',
    '& fieldset': {
      border: 0,
    },
  },
  item: {
    fontWeight: 'bold',
    color: '#981B49',
  },
  iconButton: {
    padding: 0,
    pointerEvents: 'none',
    cursor: 'default',
    color: 'inherit',
  },
  input: {
    fontWeight: 'bold',
    color: 'inherit',
  },
  icon: {
    color: 'inherit',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  selectRoot: {
    padding: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}));

const LanguageSelect = props => {
  const classes = useStyles();
  const { languages, value, onChange } = props;

  return (
    <TextField
      select
      variant="outlined"
      value={value.code}
      classes={{ root: classes.root }}
      onChange={onChange}
      SelectProps={{
        classes: {
          root: classes.selectRoot,
          icon: classes.icon,
        },
      }}
      InputProps={{
        classes: { root: classes.input },
      }}
    >
      {languages.map(language => (
        <MenuItem
          className={classes.item}
          key={language.code}
          value={language.code}
        >
          {language.description}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default LanguageSelect;
